export const GetMortgageeProperties = (
  featureFlag: boolean | string,
  data: {
    [key: string]: string;
  }
) => {
  let AddressLine1 = "";
  let AddressLine2 = "";
  let City = "";
  let Name = "";
  let State = "";
  let ZipCode = "";
  let Index = "";

  if (featureFlag) {
    ({ AddressLine1, AddressLine2, City, Name, State, ZipCode, Index } = data);
  } else {
    ({
      Mortgagee0AddressLine1: AddressLine1,
      Mortgagee0AddressLine2: AddressLine2,
      Mortgagee0City: City,
      Mortgagee0Name: Name,
      Mortgagee0State: State,
      Mortgagee0ZipCode: ZipCode,
      Mortgagee0Index: Index
    } = data);
  }

  return {
    AddressLine1,
    AddressLine2,
    City,
    Name,
    State,
    ZipCode,
    Index
  };
};
